<article class="formEditor">
    <span class="formLabel">Type</span>
    <lib-generic-dropdown
        [source]="items()"
        [config]="{
            multiple: false,
            defaultText: placeholderText(),
            itemDisplayKey: 'name'
        }"
        [selectedItem]="selectedItems()[0] || null"
        (selectedItemChange)="onSelectedItemChange($event)"
        [isReadOnly]="isReadOnly()"
        id="company"
    >
    </lib-generic-dropdown>
</article>
